<template>
  <div class="next-step-setting-instruction">
    <div class="next-step-setting-instruction__slot">
      <slot />
    </div>
    <div class="next-step-setting-instruction__steps">
      <span
        v-if="showSteps"
        class="next-step-setting-instruction__count"
      >
        Шаг {{ currentStepNumber }}/{{ stepsCount }}
      </span>
      <router-link
        id="settings-button-next-parent"
        v-if="showSteps"
        v-bind:to="nextStepNavigation()"
        class="next-step-setting-instruction__button"
      >
        Далее
      </router-link>
    </div>
  </div>
</template>

<script>

/**
 * @description Компонент следующего шага инструкции.
 */
export default {
  computed: {
    /**
     * @description Индекс текущего шага.
     * @returns {number}
     */
    currentStepIndex() {
      return this.initialSteps.findIndex((step) => step.to === this.currentRouteName);
    },
    /**
     * @description Номер текущего шага.
     * @returns {number}
     */
    currentStepNumber() {
      return this.currentStepIndex + 1;
    },
    /**
     * @description Общее количество шагов.
     * @returns {number}
     */
    stepsCount() {
      return this.initialSteps.length;
    },
    /**
     * @description Показывать шаги.
     * @returns {boolean}
     */
    showSteps() {
      return this.currentStepNumber < this.stepsCount;
    },
  },
  name: 'NextStepSettingInstruction',
  methods: {
    /**
     * @description Навигация до следующего шага.
     * @returns {Object}
     */
    nextStepNavigation() {
      const step = this.initialSteps[this.currentStepIndex + 1] ?? {};
      return {
        name: step.to,
        params: { initialAvailableSteps: this.initialSteps },
      };
    },
  },
  props: {
    initialSteps: {
      required: true,
      type: Array,
    },
    currentRouteName: {
      required: true,
      type: String,
    },
  },
};
</script>

<style lang="scss">
@use "@/scss/buttons";
.next-step-setting-instruction {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 155px;
  padding: 15px 22px;
  z-index: 2;
  background-color: white;
  box-shadow: 0px -10px 10px rgba(0, 0, 0, 0.06);
  &__steps {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 0.4;
    gap: 10px;
  }
  &__count {
    color: rgba(4, 137, 224, 1);
    font-size: 16px;
    line-height: 18px;
    font-weight: 600;
  }
  &__button {
    @include buttons.btn-blue(100%, 32px, 16px);
    max-width: 162px;
    min-width: 80px;
    text-decoration: none;
    color: #FFFFFF !important;
  }
  &__slot {
    flex: 1;
    margin-right: auto;
  }
}
@media screen and (max-width: 960px) {
  .next-step-setting-instruction {
    left: 0;
    padding: 10px;
    &__count {
      font-size: 16px;
      line-height: 18px;
    }
    &__button {
      height: 44px;
    }
  }
}

@media screen and (max-width: 600px) {
  .next-step-setting-instruction {
    &__steps {
      flex: 1;
    }
  }
}
</style>
